import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AppErrorBoundary from "./components/common/AppErrorBoundary";
import { installGlobalErrorMonitoring } from "./utils/errorMonitoring";
import './styles.css';

installGlobalErrorMonitoring();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
